export type ButtonVariant = 'filled' | 'outlined' | 'text' | 'tonal';
type MatVariant = 'stroked' | 'flat' | undefined;

export const BUTTON_MAT_VARIANTS: Record<ButtonVariant, MatVariant> = {
  tonal: 'flat',
  filled: 'flat',
  outlined: 'stroked',
  text: undefined,
};
